import { z } from 'zod';

/**
 * A duplicate is defined by matching `number`, `companyId`, and the calendar
 * date of `validFrom` against every version ever recorded for that account,
 * current or historical.
 */
export const zodValidateLedgerAccountUniquenessQueryParamsSchema = z.object({
  companyId: z.uuid(),
  number: z.string().trim().min(1).max(64),
  validFrom: z.iso.date(),
});
